import { WrenchScrewdriverIcon, ArrowPathIcon } from "@heroicons/react/24/outline";

const Maintenance = ({ onRetry, message = "This page is currently under maintenance. Please check back shortly." }) => {
  return (
    <div className="relative flex w-full items-center justify-center overflow-hidden px-4 py-12">
      <div className="relative z-10 w-full max-w-xl rounded-2xl bg-white p-8 text-center shadow-lg">
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-highlightColor shadow-lg">
          <WrenchScrewdriverIcon className="h-10 w-10 animate-pulse text-white" />
        </div>
        <h3 className="mb-3 text-2xl font-semibold text-gray-900">Maintenance in Progress</h3>

        <div className="mb-6 space-y-3">
          <p className="text-base text-gray-600">{message}</p>
        </div>

        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-highlightColor px-6 py-3 text-sm font-medium text-white shadow-lg transition-all  hover:shadow-xl focus:outline-none focus:ring-2">
            <ArrowPathIcon className="h-5 w-5" />
            Retry & Check Status
          </button>
        )}

        <div className="mt-6 border-t border-gray-200 pt-6">
          <p className="text-xs text-gray-500">For urgent issues, please contact your administrator or support team.</p>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
